module.exports = __webpack_public_path__ + "img/avg-interviews-offer.ea80e585.png";